import occoApi from '../occoAPI-module.js';
import { alertMessagePopup } from '../views/modals/others.js';

/**
 * Send activity to report later
 *
 * @param {String} activityName
 * @param {Number} photoId
 * @param {Number} robotId
 */
export function trackPhotoEvent(activityName, photoId, robotId) {
  const activityType = 'info';
  occoApi.activityCreateByRobotId(robotId, photoId, activityName, activityType, (err) => {
    if (err) {
      return alertMessagePopup(err.message_key);
    }
  });
}

/**
 * Send activity with array of images to report later
 *
 * @param {String} activityName
 * @param {[Number]} listOfPhotoId
 * @param {Number} robotId
 */
export function trackListOfPhotoEvent(activityName, listOfPhotoId, robotId) {
  const activityType = 'info';
  occoApi.activityBulkCreateByRobotId(robotId, listOfPhotoId, activityName, activityType, (err) => {
    if (err) {
      return alertMessagePopup(err.message_key);
    }
  });
}

window.trackPhotoEvent = trackPhotoEvent;
window.trackListOfPhotoEvent = trackListOfPhotoEvent;
